import React from "react"

//@ts-ignore
const HostVideo3 = ({ className, videoSrcURL, videoTitle, ...props }) => (
  <div className={className ?? "home-hero-video-wrapper"} >
  
    <iframe
      title="vimeo-player"
      src="https://player.vimeo.com/video/938340835?h=2f0e0be7da" 
      width="845" height="360"
      frameBorder="0"
      allowFullScreen
    >
    </iframe>
   
  </div>
)
export default HostVideo3;